import React from 'react';

const navItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    section: 'OVERVIEW',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="1" width="6" height="6" rx="1" />
        <rect x="9" y="1" width="6" height="6" rx="1" />
        <rect x="1" y="9" width="6" height="6" rx="1" />
        <rect x="9" y="9" width="6" height="6" rx="1" />
      </svg>
    ),
  },
  {
    id: 'certificates',
    label: 'Certificates',
    section: 'VERIFICATION',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="1" width="12" height="14" rx="1" />
        <line x1="5" y1="5" x2="11" y2="5" />
        <line x1="5" y1="8" x2="11" y2="8" />
        <circle cx="8" cy="12" r="1.5" />
      </svg>
    ),
  },
  {
    id: 'forecast',
    label: 'Demand Forecast',
    section: 'INTELLIGENCE',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="1,12 5,7 8,10 12,4 15,6" />
      </svg>
    ),
  },
  {
    id: 'faults',
    label: 'Fault Detection',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M8 1l1.5 4h4l-3 2.5 1 4L8 9l-3.5 2.5 1-4L2.5 5h4z" />
      </svg>
    ),
  },
  {
    id: 'transformer',
    label: 'Transformer AI',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="4" width="14" height="8" rx="1" />
        <line x1="4" y1="4" x2="4" y2="2" />
        <line x1="8" y1="4" x2="8" y2="2" />
        <line x1="12" y1="4" x2="12" y2="2" />
        <line x1="4" y1="12" x2="4" y2="14" />
        <line x1="8" y1="12" x2="8" y2="14" />
        <line x1="12" y1="12" x2="12" y2="14" />
      </svg>
    ),
  },
  {
    id: 'frequency',
    label: 'Frequency AI',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="1,8 3,4 5,12 7,6 9,10 11,3 13,9 15,7" />
      </svg>
    ),
  },
  {
    id: 'lowvoltage',
    label: 'Low Voltage',
    section: null,
    badge: 'M-07',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M9 1L3 9h4l-1 6 6-8H8l1-6z" />
      </svg>
    ),
  },
  {
    id: 'villagegrid',
    label: 'VillageGrid AI',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M1 14L5 6l3 4 3-6 4 10" />
        <circle cx="5" cy="6" r="1" fill="currentColor" />
        <circle cx="8" cy="10" r="1" fill="currentColor" />
        <circle cx="11" cy="4" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    id: 'advisor',
    label: 'HomeGrid AI',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="6" r="3" />
        <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      </svg>
    ),
  },
  {
    id: 'zones',
    label: 'Zone Monitor',
    section: 'GRID',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polygon points="8,1 15,5 15,11 8,15 1,11 1,5" />
      </svg>
    ),
  },
  {
    id: 'map',
    label: 'India Grid Map',
    section: null,
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M2 4l4-2 4 2 4-2v10l-4 2-4-2-4 2V4z" />
        <line x1="6" y1="2" x2="6" y2="14" />
        <line x1="10" y1="4" x2="10" y2="16" />
      </svg>
    ),
  },
  {
    id: 'carbon',
    label: 'Carbon Intelligence',
    section: 'CARBON',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="8" r="6" />
        <path d="M8 5v6M5.5 7l2.5-2 2.5 2" />
      </svg>
    ),
  },
  {
    id: 'about',
    label: 'About',
    section: 'COMPANY',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="8" r="6" />
        <line x1="8" y1="7" x2="8" y2="12" />
        <circle cx="8" cy="4.5" r="0.5" fill="currentColor" />
      </svg>
    ),
  },
];

const mobilePrimaryItems = [
  {
    id: 'dashboard',
    label: 'Overview',
    icon: (
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M3 11.5L12 4l9 7.5" />
        <path d="M5.5 10v10h13V10" />
        <path d="M9 20v-6h6v6" />
      </svg>
    ),
  },
  {
    id: 'faults',
    label: 'Alerts',
    icon: (
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M18 8a6 6 0 10-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
        <path d="M10 21h4" />
      </svg>
    ),
  },
  {
    id: 'forecast',
    label: 'Intelligence',
    icon: (
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M4 17l5-6 4 3 7-9" />
        <path d="M16 5h4v4" />
      </svg>
    ),
  },
];

export default function Layout({
  activePage,
  onNavigate,
  gridData,
  source,
}) {
  const [mobileMoreOpen, setMobileMoreOpen] = React.useState(false);
  const getISTTime = () =>
  new Date().toLocaleTimeString('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

const [time, setTime] = React.useState(getISTTime);

React.useEffect(() => {
  const timer = setInterval(() => {
    setTime(getISTTime());
  }, 1000);

  return () => clearInterval(timer);
}, []);
  React.useEffect(() => {
    setMobileMoreOpen(false);
  }, [activePage]);

  React.useEffect(() => {
    if (mobileMoreOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMoreOpen]);

  const handleMobileNavigate = (pageId) => {
    setMobileMoreOpen(false);
    onNavigate(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  let lastSection = null;

  return (
    <>
      {/* DESKTOP TOPBAR — UNCHANGED */}
      <header className="topbar">
        <div className="brand">
  <img
    src="/gridmind-logo.png"
    alt="GridMind logo"
    className="brand-logo"
  />

  <span className="brand-name">
    Grid<span>Mind</span>
  </span>
</div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontFamily: 'var(--mono)',
            fontSize: 11,
            color: 'var(--muted)',
          }}
        >
          <div className="live-dot" />
          <span>
            {source === 'live'
              ? 'Live · India National Grid'
              : 'Demo mode · simulated data'}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          {gridData && (
            <>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    fontFamily: 'var(--mono)',
                    fontSize: 13,
                    color: 'var(--green)',
                    fontWeight: 500,
                  }}
                >
                  {gridData.load} GW
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: 'var(--muted2)',
                    letterSpacing: 1,
                  }}
                >
                  Grid Load
                </div>
              </div>

              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    fontFamily: 'var(--mono)',
                    fontSize: 13,
                    color: 'var(--green)',
                    fontWeight: 500,
                  }}
                >
                  {gridData.solar} MW
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: 'var(--muted2)',
                    letterSpacing: 1,
                  }}
                >
                  Solar
                </div>
              </div>
            </>
          )}

          <div
            style={{
              fontFamily: 'var(--mono)',
              fontSize: 12,
              color: 'var(--muted)',
              borderLeft: '1px solid var(--border)',
              paddingLeft: 16,
            }}
          >
            {time}
          </div>
        </div>
      </header>

      {/* DESKTOP SIDEBAR — UNCHANGED */}
      <nav className="sidebar">
        {navItems.map((item) => {
          const showSection =
            item.section && item.section !== lastSection;

          if (item.section) {
            lastSection = item.section;
          }

          return (
            <React.Fragment key={item.id}>
              {showSection && (
                <div className="nav-section-label">
                  {item.section}
                </div>
              )}

              <button
                className={`nav-item${
                  activePage === item.id ? ' active' : ''
                }`}
                onClick={() => onNavigate(item.id)}
              >
                {item.icon}
                {item.label}

                {item.badge && (
                  <span
                    className={`nav-badge${
                      item.badgeOk ? ' ok' : ''
                    }`}
                  >
                    {item.badge}
                  </span>
                )}
              </button>
            </React.Fragment>
          );
        })}

        <div
          className="sidebar-footer"
          style={{
            marginTop: 'auto',
            padding: '16px 20px',
            borderTop: '1px solid var(--border)',
          }}
        >
          <div
            style={{
              fontFamily: 'var(--mono)',
              fontSize: 9,
              color: 'var(--muted2)',
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              marginBottom: 6,
            }}
          >
            System Status
          </div>

          <div
            style={{
              fontSize: 12,
              color: 'var(--muted)',
            }}
          >
            All systems nominal
          </div>

          <div
            style={{
              marginTop: 8,
              height: 3,
              background: 'var(--muted3)',
              borderRadius: 1,
            }}
          >
            <div
              style={{
                width: '94%',
                height: '100%',
                background: 'var(--green)',
                borderRadius: 1,
              }}
            />
          </div>

          <div
            style={{
              marginTop: 4,
              fontFamily: 'var(--mono)',
              fontSize: 10,
              color: 'var(--green)',
            }}
          >
            94% efficiency
          </div>

          <div
            style={{
              fontSize: 9,
              color: 'var(--muted2)',
              fontFamily: 'var(--mono)',
              marginTop: 6,
              letterSpacing: 1,
            }}
          >
            © 2026 IntelliLearn AI Pvt. Ltd.
          </div>
        </div>
      </nav>

      {/* MOBILE BOTTOM NAV */}
      <nav className="mobile-nav">
        <div className="mnav-items">
          {mobilePrimaryItems.map((item) => (
            <button
              key={item.id}
              className={`mnav-item${
                activePage === item.id && !mobileMoreOpen
                  ? ' active'
                  : ''
              }`}
              onClick={() => handleMobileNavigate(item.id)}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}

          <button
            className={`mnav-item${
              mobileMoreOpen ? ' active' : ''
            }`}
            onClick={() => setMobileMoreOpen(true)}
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
            >
              <circle cx="5" cy="12" r="1.2" fill="currentColor" />
              <circle cx="12" cy="12" r="1.2" fill="currentColor" />
              <circle cx="19" cy="12" r="1.2" fill="currentColor" />
            </svg>
            <span>More</span>
          </button>
        </div>
      </nav>

      {/* MOBILE MORE DRAWER */}
      {mobileMoreOpen && (
        <div
          className="mobile-more-overlay"
          onClick={() => setMobileMoreOpen(false)}
        >
          <div
            className="mobile-more-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mobile-more-handle" />

            <div className="mobile-more-header">
              <div>
                <div className="mobile-more-eyebrow">
                  GRIDMIND
                </div>
                <h2>All Modules</h2>
                <p>
                  Access the complete GridMind intelligence workspace.
                </p>
              </div>

              <button
                className="mobile-more-close"
                onClick={() => setMobileMoreOpen(false)}
                aria-label="Close modules"
              >
                ×
              </button>
            </div>

            <div className="mobile-module-grid">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  className={`mobile-module-card${
                    activePage === item.id ? ' active' : ''
                  }`}
                  onClick={() => handleMobileNavigate(item.id)}
                >
                  <div className="mobile-module-icon">
                    {React.cloneElement(item.icon, {
                      width: 20,
                      height: 20,
                    })}
                  </div>

                  <span>{item.label}</span>

                  {item.badge && (
                    <small>{item.badge}</small>
                  )}
                </button>
              ))}
            </div>

            <div className="mobile-more-footer">
              <span className="mobile-status-dot" />
              <span>
                {source === 'live'
                  ? 'External data source connected'
                  : 'Demo environment · simulated data'}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}